module.exports = __webpack_public_path__ + "img/jp.1dbf51e2.svg";